import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { Modal, useBlockRoute } from 'components/Modals/AskBeforeLeave';

const AskBeforeLeaveForm: FC = () => {
  const { dirty, submitForm } = useFormikContext();
  const {
    isPublishing,
    modalIsOpen,
    handleCancel,
    handleDiscard,
    handleConfirm,
  } = useBlockRoute({ shouldBlock: dirty, onPublish: submitForm });
  return (
    <Modal
      open={modalIsOpen}
      isPublishing={isPublishing}
      onCancel={handleCancel}
      onDiscard={handleDiscard}
      onPublish={handleConfirm}
    />
  );
};

export default AskBeforeLeaveForm;

// TODO: TFR-29 add story to component
